export const environment = {
    production: false,
  apiUrl: "https://clmpvapi.walaiautolib.com/",
  // apiUrl: 'https://opac-api.wu.ac.th/',
  // basePath: 'pvapi',
  // apiUrl: 'https://wunca41.walaiautolib.com/',
  basePath: 'pvapi',
    version: 'build.20250121.1.0.7'
};
